<template>
  <KeyValue
    :caption="caption"
    class="mr-6"
    :data-qa="dataQa"
    :line="line">
    <div>
      <template v-if="value && value !== '0001-01-01T00:00:00'">
        <span>{{ $d(new Date(value), 'shortDate') }} </span>
        <span>{{ $d(new Date(value), 'time') }}</span>
      </template>
      <span v-else>–</span>
    </div>
  </KeyValue>
</template>
<script>
/**
* Отображение даты в формате ключ - значение
* @category components
* @vue-prop {String} caption - Описание
* @vue-prop {String} value - Значение
*/
export default {
  name: 'KeyDate',
  props: {
    caption: {
      type: String
    },
    value: {
      type: String
    },
    dataQa: {
      type: String,
      default: 'key-value'
    },
    line: {
      type: Boolean
    }
  }
}
</script>
